import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Page404 from "containers/Page404/Page404";
import MyRouter from "routers/index";
import FireworksOverlay from "components/NationalDayBanner/NationalDayBanner";
import "./index.css";

import {
  apiGetCategories,
  apiGetMenuAttractions,
  apiGetHomeBanners,
  apiGetWelnessCategories,
  apiGetWellnessBanners,
} from "apis/masterData";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FloatingWhatsApp } from "react-floating-whatsapp";
import { Helmet } from "react-helmet";
import config from "config/config";
import TMConfetti from "components/Confetti/Confetti";

function App() {
  const dispatch = useDispatch();
  const {
    categories,
    menuAttractions,
    homeBanners,
    welnessCategories,
    wellnessBanners,
  } = useSelector((state) => state.masterData);

  const [isPushTokenFound, setPushTokenFound] = useState(false);

  const getMasterData = async () => {
    if (!categories) await apiGetCategories(dispatch);
    if (!welnessCategories) await apiGetWelnessCategories(dispatch);
    if (!menuAttractions) await apiGetMenuAttractions(dispatch);
    if (!homeBanners) await apiGetHomeBanners(dispatch);
    if (!wellnessBanners) await apiGetWellnessBanners(dispatch);
  };

  useEffect(() => {
    getMasterData();
  }, []);

  useEffect(() => {
  const interval = setInterval(() => {
    const shadowHost = document.querySelector("zapier-interfaces-chatbot-embed");
    if (shadowHost && shadowHost.shadowRoot) {
      const iframe = shadowHost.shadowRoot.querySelector("iframe");
      if (iframe) {
        iframe.style.bottom = "42px";
        iframe.style.position = "fixed";
        iframe.style.right = "0px";
        iframe.style.zIndex = "99999";
        clearInterval(interval);
      }
    }
  }, 300);

  return () => clearInterval(interval);
}, []);


  let metaDescription = `Journey Beyond Expectations: Discover the Other Side of UAE through our seamless ticketing experience`;
  let metaTitle = `Ticket Magic — Buy Tickets Online & Register for Events in UAE`;

  switch (config.region) {
    case "saudi":
      metaTitle = `Ticket Magic — Buy Tickets Online & Register for Events in Saudi Arabia`;
      metaDescription = `Journey Beyond Expectations: Discover the Other Side of Saudi Arabia through our seamless ticketing experience`;
      break;

    case "canada":
      metaTitle = `Ticket Magic — Buy Tickets Online & Register for Events in Canada`;
      metaDescription = `Journey Beyond Expectations: Discover the Other Side of Canada through our seamless ticketing experience`;
      break;

    default:
      break;
  }

  return (
    <div className="bg-white text-base dark:bg-neutral-900 text-neutral-900 dark:text-neutral-200">

      {/* SEO META TAGS */}
      <Helmet>
        <title>{metaTitle}</title>
        <meta name="title" content={metaTitle} />
        <meta name="description" content={metaDescription} />

        {/* OpenGraph */}
        <meta property="og:type" content="article" />
        <meta property="og:title" content={metaTitle} />
        <meta property="og:description" content={metaDescription} />
        <meta property="og:image" content={`Ticket_Magic.jpg`} />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={metaTitle} />
        <meta name="twitter:description" content={metaDescription} />
        <meta name="twitter:image" content={`Ticket_Magic.jpg`} />

        {/* Zapier Chatbot Script */}
        <script
          async
          type="module"
          src="https://interfaces.zapier.com/assets/web-components/zapier-interfaces/zapier-interfaces.esm.js"
        />
      </Helmet>

      {/* MAIN ROUTER */}
      <MyRouter />

      <ToastContainer autoClose={5000} />
      <TMConfetti />

      {/* FLOATING WHATSAPP */}
      <div id="floating-whatsapp">
        <FloatingWhatsApp
          phoneNumber={config.contacts.whatsapp}
          accountName="Ticket Magic Customer Service"
          statusMessage={config.contacts.whatsapp}
          darkMode={localStorage.theme === "dark"}
          className="float-wa-icon hardText-ltr"
        />
      </div>

      {/* FIXED ZAPIER CHATBOT */}
      <div
        className="zapier-chatbot-container"
        style={{
          position: "fixed",
          bottom: "32px",
          right: "20px",
          zIndex: 1000,
        }}
      >
        <zapier-interfaces-chatbot-embed
          is-popup="true"
          chatbot-id="cmhp3fp4k001gwj4io8ygz6pb"
        />
      </div>
    </div>
  );
}

export default App;
